<template>
  <div id="tf-bodorcam">
    <div class="section-title text-center center">
      <h2>{{ $t("home.look") }}<strong> BodorCAM</strong></h2>
      <div class="line">
        <hr />
      </div>
      <div class="clearfix"></div>
      <small
        ><em> {{ $t("home.camin") }} </em></small
      >
    </div>
    <div class="container">
      <!-- 新版BodorCAM正在开发中，敬请期待！ -->
      <div class="container_box">
        <div class="container_title">
          <div class="container_title_left"></div>
          <div class="container_title_right">V1.0/2.0版本</div>
        </div>
        <div class="container_content">
          <div class="container_content_left">
            <a-skeleton active :loading="loading1">
              <div class="version">
                <div class="vers_head">
                  <div class="vers_head_left">
                    <div class="vers_fileiconBox">
                      <img
                        class="vers_fileicon"
                        :title="softWare.fileurl"
                        :src="imgsUrlO"
                        alt="文件"
                        @click="download1"
                        v-if="props.screenSize > 991"
                      />
                    </div>
                    <div class="vers_title">
                      <div class="vers_title_bold">
                        BodorNest Tube V1.0{{ $t("home.tubein") }}
                      </div>
                      <div class="vers_title_small" v-if="props.screenSize > 991">
                        {{ $t("index.downloadInfo2") }}
                      </div>
                    </div>
                  </div>

                  <div class="vers_btnBox">
                    <div class="vers_btngroup">
                      <a-button
                        class="jumpBtn noradius vers_button"
                        @click="download('bodornesttube')"
                        >{{ $t("home.download") }}</a-button
                      >
                      <a-button
                        class="jumpBtn noradius vers_button"
                        @click="video('tubevideo')"
                        >{{ $t("home.video") }}</a-button
                      >
                    </div>
                  </div>
                </div>
                <div class="vers_card_content">
                  <div class="info">
                    <!-- <div class="verticalline" v-if="props.screenSize > 991"></div> -->
                    <div class="infocontent">
                      <div class="infoitems">
                        <div class="infotitle">{{ $t("index.softwareName") }}</div>
                        <div class="infonumber" :title="softWare.filename">
                          {{ softWare.filename }}
                        </div>
                      </div>
                      <div class="infoitems">
                        <div class="infotitle">{{ $t("index.softwareAuthor") }}</div>
                        <div class="infonumber" :title="softWare.type">
                          {{ softWare.type }}
                        </div>
                      </div>
                      <div class="infoitems">
                        <div class="infotitle">{{ $t("index.newVersion") }}</div>
                        <div class="infonumber" :title="softWare.versionnumber">
                          {{ softWare.versionnumber }}
                        </div>
                      </div>
                      <div class="infoitems">
                        <div class="infotitle">{{ $t("index.updateTime") }}</div>
                        <div class="infonumber" :title="softWare.createtime">
                          {{ softWare.createtime }}
                        </div>
                      </div>
                    </div>
                    <!-- <div class="verticalline" v-if="props.screenSize > 767"></div> -->
                  </div>
                  <div class="introduct">
                    <a-collapse v-model:activeKey="activeKey" :bordered="false">
                      <template #expandIcon="{ isActive }">
                        <caret-right-outlined :rotate="isActive ? 90 : 0" />
                      </template>
                      <a-collapse-panel
                        key="1"
                        :header="$t('index.launch')"
                        class="customstyle"
                      >
                        <pre class="artticle">{{ softWare.remark }}</pre>
                      </a-collapse-panel>
                    </a-collapse>
                  </div>
                </div>
              </div>
            </a-skeleton>
          </div>
          <div class="container_content_right">
            <!-- BodorNest V2.0(板切) -->
            <a-skeleton active :loading="loading4">
              <div class="version">
                <div class="vers_head">
                  <div class="vers_head_left">
                    <div class="vers_fileiconBox">
                      <img
                        class="vers_fileicon"
                        :title="softWare4.fileurl"
                        :src="imgsUrlT"
                        alt="文件"
                        @click="download4"
                        v-if="props.screenSize > 991"
                      />
                    </div>
                    <div class="vers_title">
                      <div class="vers_title_bold">
                        BodorNest V2.0{{ $t("home.nestin") }}
                      </div>
                      <div class="vers_title_small" v-if="props.screenSize > 991">
                        {{ $t("index.downloadInfo2") }}
                      </div>
                    </div>
                  </div>
                  <div class="vers_btnBox">
                    <div class="vers_btngroup">
                      <a-button
                        class="jumpBtn noradius vers_button"
                        @click="download('bodornest')"
                        >{{ $t("home.download") }}</a-button
                      >
                      <a-button
                        class="jumpBtn noradius vers_button"
                        @click="video('nestvideo')"
                        >{{ $t("home.video") }}</a-button
                      >
                    </div>
                  </div>
                </div>
                <div class="vers_card_content">
                  <div class="info">
                    <!-- <div class="verticalline" v-if="props.screenSize > 991"></div> -->
                    <div class="infocontent">
                      <div class="infoitems">
                        <div class="infotitle">{{ $t("index.softwareName") }}</div>
                        <div class="infonumber" :title="softWare4.filename">
                          {{ softWare4.filename }}
                        </div>
                      </div>
                      <div class="infoitems">
                        <div class="infotitle">{{ $t("index.softwareAuthor") }}</div>
                        <div class="infonumber" :title="softWare4.type">
                          {{ softWare4.type }}
                        </div>
                      </div>
                      <div class="infoitems">
                        <div class="infotitle">{{ $t("index.newVersion") }}</div>
                        <div class="infonumber" :title="softWare4.versionnumber">
                          {{ softWare4.versionnumber }}
                        </div>
                      </div>
                      <div class="infoitems">
                        <div class="infotitle">{{ $t("index.updateTime") }}</div>
                        <div class="infonumber" :title="softWare4.createtime">
                          {{ softWare4.createtime }}
                        </div>
                      </div>
                    </div>
                    <!-- <div class="verticalline" v-if="props.screenSize > 767"></div> -->
                  </div>
                  <div class="introduct">
                    <a-collapse v-model:activeKey="activeKey" :bordered="false">
                      <template #expandIcon="{ isActive }">
                        <caret-right-outlined :rotate="isActive ? 90 : 0" />
                      </template>
                      <a-collapse-panel
                        key="4"
                        :header="$t('index.launch')"
                        class="customstyle"
                      >
                        <pre class="artticle">{{ softWare4.remark }}</pre>
                      </a-collapse-panel>
                    </a-collapse>
                  </div>
                </div>
              </div>
            </a-skeleton>
          </div>
        </div>
      </div>
      <div class="container_box">
        <div class="container_title">
          <div class="container_title_left"></div>
          <div class="container_title_right">V1.5版本</div>
        </div>
        <div class="container_content">
          <div class="container_content_left">
            <!-- BodorNest Tube V1.5 -->
            <a-skeleton active :loading="loading3">
              <div class="version">
                <div class="vers_head">
                  <div class="vers_head_left">
                    <div class="vers_fileiconBox">
                      <img
                        class="vers_fileicon"
                        :title="softWare3.fileurl"
                        :src="imgsUrlH"
                        alt="文件"
                        @click="download3"
                        v-if="props.screenSize > 991"
                      />
                    </div>
                    <div class="vers_title">
                      <div class="vers_title_bold">
                        BodorNest Tube V1.5{{ $t("home.tubein") }}
                      </div>
                      <div class="vers_title_small" v-if="props.screenSize > 991">
                        {{ $t("index.downloadInfo2") }}
                      </div>
                    </div>
                  </div>
                  <div class="vers_btnBox">
                    <div class="vers_btngroup">
                      <a-button
                        class="jumpBtn noradius vers_button"
                        @click="download('bodornest1.5')"
                        >{{ $t("home.download") }}</a-button
                      >
                      <a-button
                        class="jumpBtn noradius vers_button"
                        @click="video('1.5video')"
                        >{{ $t("home.video") }}</a-button
                      >
                    </div>
                  </div>
                </div>
                <div class="vers_card_content">
                  <div class="info">
                    <!-- <div class="verticalline" v-if="props.screenSize > 991"></div> -->
                    <div class="infocontent">
                      <div class="infoitems">
                        <div class="infotitle">{{ $t("index.softwareName") }}</div>
                        <div class="infonumber" :title="softWare3.filename">
                          {{ softWare3.filename }}
                        </div>
                      </div>
                      <div class="infoitems">
                        <div class="infotitle">{{ $t("index.softwareAuthor") }}</div>
                        <div class="infonumber" :title="softWare3.type">
                          {{ softWare3.type }}
                        </div>
                      </div>
                      <div class="infoitems">
                        <div class="infotitle">{{ $t("index.newVersion") }}</div>
                        <div class="infonumber" :title="softWare3.versionnumber">
                          {{ softWare3.versionnumber }}
                        </div>
                      </div>
                      <div class="infoitems">
                        <div class="infotitle">{{ $t("index.updateTime") }}</div>
                        <div class="infonumber" :title="softWare3.createtime">
                          {{ softWare3.createtime }}
                        </div>
                      </div>
                    </div>
                    <!-- <div class="verticalline" v-if="props.screenSize > 767"></div> -->
                  </div>
                  <div class="introduct">
                    <a-collapse v-model:activeKey="activeKey" :bordered="false">
                      <template #expandIcon="{ isActive }">
                        <caret-right-outlined :rotate="isActive ? 90 : 0" />
                      </template>
                      <a-collapse-panel
                        key="2"
                        :header="$t('index.launch')"
                        class="customstyle"
                      >
                        <pre class="artticle">{{ softWare3.remark }}</pre>
                      </a-collapse-panel>
                    </a-collapse>
                  </div>
                </div>
              </div>
            </a-skeleton>
          </div>
          <div class="container_content_right">
            <a-skeleton active :loading="loading2">
              <div class="version">
                <div class="vers_head">
                  <div class="vers_head_left">
                    <div class="vers_fileiconBox">
                      <img
                        class="vers_fileicon"
                        :title="softWare2.fileurl"
                        :src="imgsUrlH"
                        alt="文件"
                        @click="download2"
                        v-if="props.screenSize > 991"
                      />
                    </div>
                    <div class="vers_title">
                      <div class="vers_title_bold">
                        BodorNest V1.5{{ $t("home.nestin") }}
                      </div>
                      <div class="vers_title_small" v-if="props.screenSize > 991">
                        {{ $t("index.downloadInfo2") }}
                      </div>
                    </div>
                  </div>
                  <div class="vers_btnBox">
                    <div class="vers_btngroup">
                      <a-button
                        class="jumpBtn noradius vers_button"
                        @click="download('nestdown1.0')"
                        >{{ $t("home.download") }}</a-button
                      >
                      <a-button
                        class="jumpBtn noradius vers_button"
                        @click="video('nestvideo1.0')"
                        >{{ $t("home.video") }}</a-button
                      >
                    </div>
                  </div>
                </div>
                <div class="vers_card_content">
                  <div class="info">
                    <!-- <div class="verticalline" v-if="props.screenSize > 991"></div> -->
                    <div class="infocontent">
                      <div class="infoitems">
                        <div class="infotitle">{{ $t("index.softwareName") }}</div>
                        <div class="infonumber" :title="softWare2.filename">
                          {{ softWare2.filename }}
                        </div>
                      </div>
                      <div class="infoitems">
                        <div class="infotitle">{{ $t("index.softwareAuthor") }}</div>
                        <div class="infonumber" :title="softWare2.type">
                          {{ softWare2.type }}
                        </div>
                      </div>
                      <div class="infoitems">
                        <div class="infotitle">{{ $t("index.newVersion") }}</div>
                        <div class="infonumber" :title="softWare2.versionnumber">
                          {{ softWare2.versionnumber }}
                        </div>
                      </div>
                      <div class="infoitems">
                        <div class="infotitle">{{ $t("index.updateTime") }}</div>
                        <div class="infonumber" :title="softWare2.createtime">
                          {{ softWare2.createtime }}
                        </div>
                      </div>
                    </div>
                    <!-- <div class="verticalline" v-if="props.screenSize > 767"></div> -->
                  </div>
                  <div class="introduct">
                    <a-collapse v-model:activeKey="activeKey" :bordered="false">
                      <template #expandIcon="{ isActive }">
                        <caret-right-outlined :rotate="isActive ? 90 : 0" />
                      </template>
                      <a-collapse-panel
                        key="3"
                        :header="$t('index.launch')"
                        class="customstyle"
                      >
                        <pre class="artticle">{{ softWare2.remark }}</pre>
                      </a-collapse-panel>
                    </a-collapse>
                  </div>
                </div>
              </div>
            </a-skeleton>
          </div>
        </div>
      </div>

      <!-- <div class="skletonBox">
        <a-skeleton active :loading="loading1">
          <div class="card">
            <div class="card-head">
              <div>BodorNest Tube V1.0{{ $t("home.tubein") }}</div>
              <div v-if="props.screenSize > 991">{{ $t("index.downloadInfo2") }}</div>
            </div>
            <div class="card-content">
              <div class="info">
                <img
                  class="fileicon"
                  :title="softWare.fileurl"
                  :src="imgsUrl"
                  alt="文件"
                  @click="download1"
                  v-if="props.screenSize > 991"
                />
                <div class="verticalline" v-if="props.screenSize > 991"></div>
                <div class="infocontent">
                  <div class="infoitems">
                    <div class="infotitle">{{ $t("index.softwareName") }}</div>
                    <div class="infonumber" :title="softWare.filename">
                      {{ softWare.filename }}
                    </div>
                  </div>
                  <div class="infoitems">
                    <div class="infotitle">{{ $t("index.softwareAuthor") }}</div>
                    <div class="infonumber" :title="softWare.type">
                      {{ softWare.type }}
                    </div>
                  </div>
                  <div class="infoitems">
                    <div class="infotitle">{{ $t("index.newVersion") }}</div>
                    <div class="infonumber" :title="softWare.versionnumber">
                      {{ softWare.versionnumber }}
                    </div>
                  </div>
                  <div class="infoitems">
                    <div class="infotitle">{{ $t("index.updateTime") }}</div>
                    <div class="infonumber" :title="softWare.createtime">
                      {{ softWare.createtime }}
                    </div>
                  </div>
                </div>
                <div class="verticalline" v-if="props.screenSize > 767"></div>
                <div class="btngroup">
                  <a-button class="jumpBtn noradius" @click="download('bodornesttube')">{{
                    $t("home.download")
                  }}</a-button>
                  <a-button class="jumpBtn noradius" @click="video('tubevideo')">{{
                    $t("home.video")
                  }}</a-button>
                </div>
              </div>
              <div class="introduct">
                <a-collapse v-model:activeKey="activeKey" :bordered="false">
                  <template #expandIcon="{ isActive }">
                    <caret-right-outlined :rotate="isActive ? 90 : 0" />
                  </template>
                  <a-collapse-panel
                    key="1"
                    :header="$t('index.launch')"
                    class="customstyle"
                  >
                    <pre class="artticle">{{ softWare.remark }}</pre>
                  </a-collapse-panel>
                </a-collapse>
              </div>
            </div>
          </div>
        </a-skeleton>
        <a-skeleton active :loading="loading4">
          <div class="card">
            <div class="card-head">
              <div>BodorNest V2.0{{ $t("home.nestin") }}</div>
              <div v-if="props.screenSize > 991">{{ $t("index.downloadInfo2") }}</div>
            </div>
            <div class="card-content">
              <div class="info">
                <img
                  class="fileicon"
                  :title="softWare4.fileurl"
                  :src="imgsUrl"
                  alt="文件"
                  @click="download4"
                  v-if="props.screenSize > 991"
                />
                <div class="verticalline" v-if="props.screenSize > 991"></div>
                <div class="infocontent">
                  <div class="infoitems">
                    <div class="infotitle">{{ $t("index.softwareName") }}</div>
                    <div class="infonumber" :title="softWare4.filename">
                      {{ softWare4.filename }}
                    </div>
                  </div>
                  <div class="infoitems">
                    <div class="infotitle">{{ $t("index.softwareAuthor") }}</div>
                    <div class="infonumber" :title="softWare4.type">
                      {{ softWare4.type }}
                    </div>
                  </div>
                  <div class="infoitems">
                    <div class="infotitle">{{ $t("index.newVersion") }}</div>
                    <div class="infonumber" :title="softWare4.versionnumber">
                      {{ softWare4.versionnumber }}
                    </div>
                  </div>
                  <div class="infoitems">
                    <div class="infotitle">{{ $t("index.updateTime") }}</div>
                    <div class="infonumber" :title="softWare4.createtime">
                      {{ softWare4.createtime }}
                    </div>
                  </div>
                </div>
                <div class="verticalline" v-if="props.screenSize > 767"></div>
                <div class="btngroup">
                  <a-button class="jumpBtn noradius" @click="download('nestdown1.0')">{{
                    $t("home.download")
                  }}</a-button>
                  <a-button class="jumpBtn noradius" @click="video('nestvideo1.0')">{{
                    $t("home.video")
                  }}</a-button>
                </div>
              </div>
              <div class="introduct">
                <a-collapse v-model:activeKey="activeKey" :bordered="false">
                  <template #expandIcon="{ isActive }">
                    <caret-right-outlined :rotate="isActive ? 90 : 0" />
                  </template>
                  <a-collapse-panel
                    key="4"
                    :header="$t('index.launch')"
                    class="customstyle"
                  >
                    <pre class="artticle">{{ softWare4.remark }}</pre>
                  </a-collapse-panel>
                </a-collapse>
              </div>
            </div>
          </div>
        </a-skeleton>
      </div> -->

      <!-- <div class="skletonBox">
        <a-skeleton active :loading="loading3">
          <div class="card">
            <div class="card-head">
              <div>BodorNest Tube V1.5{{ $t("home.tubein") }}</div>
              <div v-if="props.screenSize > 991">{{ $t("index.downloadInfo2") }}</div>
            </div>
            <div class="card-content">
              <div class="info">
                <img
                  class="fileicon"
                  :title="softWare3.fileurl"
                  :src="imgsUrl"
                  alt="文件"
                  @click="download3"
                  v-if="props.screenSize > 991"
                />
                <div class="verticalline" v-if="props.screenSize > 991"></div>
                <div class="infocontent">
                  <div class="infoitems">
                    <div class="infotitle">{{ $t("index.softwareName") }}</div>
                    <div class="infonumber" :title="softWare3.filename">
                      {{ softWare3.filename }}
                    </div>
                  </div>
                  <div class="infoitems">
                    <div class="infotitle">{{ $t("index.softwareAuthor") }}</div>
                    <div class="infonumber" :title="softWare3.type">
                      {{ softWare3.type }}
                    </div>
                  </div>
                  <div class="infoitems">
                    <div class="infotitle">{{ $t("index.newVersion") }}</div>
                    <div class="infonumber" :title="softWare3.versionnumber">
                      {{ softWare3.versionnumber }}
                    </div>
                  </div>
                  <div class="infoitems">
                    <div class="infotitle">{{ $t("index.updateTime") }}</div>
                    <div class="infonumber" :title="softWare3.createtime">
                      {{ softWare3.createtime }}
                    </div>
                  </div>
                </div>
                <div class="verticalline" v-if="props.screenSize > 767"></div>
                <div class="btngroup">
                  <a-button class="jumpBtn noradius" @click="download('bodornest1.5')">{{
                    $t("home.download")
                  }}</a-button>
                  <a-button class="jumpBtn noradius" @click="video('1.5video')">{{
                    $t("home.video")
                  }}</a-button>
                </div>
              </div>
              <div class="introduct">
                <a-collapse v-model:activeKey="activeKey" :bordered="false">
                  <template #expandIcon="{ isActive }">
                    <caret-right-outlined :rotate="isActive ? 90 : 0" />
                  </template>
                  <a-collapse-panel
                    key="2"
                    :header="$t('index.launch')"
                    class="customstyle"
                  >
                    <pre class="artticle">{{ softWare3.remark }}</pre>
                  </a-collapse-panel>
                </a-collapse>
              </div>
            </div>
          </div>
        </a-skeleton>
        <a-skeleton active :loading="loading2">
          <div class="card">
            <div class="card-head">
              <div>BodorNest V1.5{{ $t("home.nestin") }}</div>
              <div v-if="props.screenSize > 991">{{ $t("index.downloadInfo2") }}</div>
            </div>
            <div class="card-content">
              <div class="info">
                <img
                  class="fileicon"
                  :title="softWare2.fileurl"
                  :src="imgsUrl"
                  alt="文件"
                  @click="download2"
                  v-if="props.screenSize > 991"
                />
                <div class="verticalline" v-if="props.screenSize > 991"></div>
                <div class="infocontent">
                  <div class="infoitems">
                    <div class="infotitle">{{ $t("index.softwareName") }}</div>
                    <div class="infonumber" :title="softWare2.filename">
                      {{ softWare2.filename }}
                    </div>
                  </div>
                  <div class="infoitems">
                    <div class="infotitle">{{ $t("index.softwareAuthor") }}</div>
                    <div class="infonumber" :title="softWare2.type">
                      {{ softWare2.type }}
                    </div>
                  </div>
                  <div class="infoitems">
                    <div class="infotitle">{{ $t("index.newVersion") }}</div>
                    <div class="infonumber" :title="softWare2.versionnumber">
                      {{ softWare2.versionnumber }}
                    </div>
                  </div>
                  <div class="infoitems">
                    <div class="infotitle">{{ $t("index.updateTime") }}</div>
                    <div class="infonumber" :title="softWare2.createtime">
                      {{ softWare2.createtime }}
                    </div>
                  </div>
                </div>
                <div class="verticalline" v-if="props.screenSize > 767"></div>
                <div class="btngroup">
                  <a-button class="jumpBtn noradius" @click="download('bodornest')">{{
                    $t("home.download")
                  }}</a-button>
                  <a-button class="jumpBtn noradius" @click="video('nestvideo')">{{
                    $t("home.video")
                  }}</a-button>
                </div>
              </div>
              <div class="introduct">
                <a-collapse v-model:activeKey="activeKey" :bordered="false">
                  <template #expandIcon="{ isActive }">
                    <caret-right-outlined :rotate="isActive ? 90 : 0" />
                  </template>
                  <a-collapse-panel
                    key="3"
                    :header="$t('index.launch')"
                    class="customstyle"
                  >
                    <pre class="artticle">{{ softWare2.remark }}</pre>
                  </a-collapse-panel>
                </a-collapse>
              </div>
            </div>
          </div>
        </a-skeleton>
      </div> -->
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { GlobalOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { useI18n } from "vue-i18n";
import { CaretRightOutlined } from "@ant-design/icons-vue";
import axios from "axios";
import { defineProps } from "vue";
const props = defineProps({
  screenSize: {
    type: Number,
    default: 1920,
  },
});

const i18n = useI18n();

let router = useRouter();

const loading1 = ref(false);
const loading2 = ref(false);
const loading3 = ref(false);
const loading4 = ref(false);
const activeKey = ref([]);
const imgsUrl = ref(require("@/assets/img/device/file.png"));
const imgsUrlO = ref(require("@/assets/img/device/Frame1.png"));
const imgsUrlT = ref(require("@/assets/img/device/Frame2.png"));
const imgsUrlH = ref(require("@/assets/img/device/Frame3.png"));

const softWare = ref({});
const softWare2 = ref({});
const softWare3 = ref({});
const softWare4 = ref({});

loading1.value = true;
axios
  .post("/api/Cam/GetCamAssistant", {
    ProductType: "0",
  })
  .then((response) => {
    if (response.data.ReturnData.length > 0) {
      softWare.value = response.data.ReturnData[0];
      softWare.value.fileurl = "https://apicloud.bodor.com" + softWare.value.fileurl;
    } else {
      message.error(response.data.ReturnMsg);
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {
    loading1.value = false;
  });

loading2.value = true;
axios
  .post("/api/Cam/GetCamAssistant", {
    ProductType: "3",
  })
  .then((response) => {
    if (response.data.ReturnData.length > 0) {
      softWare2.value = response.data.ReturnData[0];
      softWare2.value.fileurl = "https://apicloud.bodor.com" + softWare2.value.fileurl;
    } else {
      message.error(response.data.ReturnMsg);
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {
    loading2.value = false;
  });

loading3.value = true;
axios
  .post("/api/Cam/GetCamAssistant", {
    ProductType: "2",
  })
  .then((response) => {
    if (Array.isArray(response.data.ReturnData)) {
      softWare3.value = response.data.ReturnData[0];
      softWare3.value.fileurl = "https://apicloud.bodor.com" + softWare3.value.fileurl;
    } else {
      softWare3.value = softWare2.value;
      softWare3.value.fileurl = "https://apicloud.bodor.com" + softWare2.value.fileurl;
      message.error(response.data.ReturnMsg);
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {
    loading3.value = false;
  });

//bodorNest2.0
loading4.value = true;
axios
  .post("/api/Cam/GetCamAssistant", {
    ProductType: "1",
  })
  .then((response) => {
    console.log("2.0:", response.data);
    if (Array.isArray(response.data.ReturnData)) {
      softWare4.value = response.data.ReturnData[0];
      softWare4.value.fileurl = "https://apicloud.bodor.com" + softWare4.value.fileurl;
    } else {
      message.error(response.data.ReturnMsg);
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {
    loading4.value = false;
  });

const cam = () => {
  router.push("/visitor/software");
};

const video = (type) => {
  if (type == "tubevideo" || type == "1.5video" || type == "nestvideo1.0") {
    message.info("暂无视频");
  } else {
    router.push(`/${type}`);
  }
};

function download(type) {
  console.log(type);
  router.push(`/${type}/true`);
}

const download1 = () => {
  let link = document.createElement("a");
  //创建一个a标签
  link.style.display = "none";
  //将a标签隐藏
  link.href = softWare.value.fileurl;
  //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
  link.setAttribute("download", softWare.value.filename);
  // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
  document.body.appendChild(link);
  //将上面创建的a标签加入到body的尾部
  link.click();
  axios
    .post("/api/Cam/AllowInsertDownload", {
      CamEdition: softWare.value.id,
    })
    .then((response) => {
      if (response.data.code != 200) {
        message.error(response.data.info);
      }
    })
    .catch((error) => {
      console.error(error);
    });
};

const download2 = () => {
  let link = document.createElement("a");
  //创建一个a标签
  link.style.display = "none";
  //将a标签隐藏
  link.href = softWare2.value.fileurl;
  //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
  link.setAttribute("download", softWare2.value.filename);
  // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
  document.body.appendChild(link);
  //将上面创建的a标签加入到body的尾部
  link.click();
  axios
    .post("/api/Cam/AllowInsertDownload", {
      CamEdition: softWare2.value.id,
    })
    .then((response) => {
      if (response.data.code != 200) {
        message.error(response.data.info);
      }
    })
    .catch((error) => {
      console.error(error);
    });
};

const download3 = () => {
  let link = document.createElement("a");
  //创建一个a标签
  link.style.display = "none";
  //将a标签隐藏
  link.href = softWare3.value.fileurl;
  //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
  link.setAttribute("download", softWare3.value.filename);
  // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
  document.body.appendChild(link);
  //将上面创建的a标签加入到body的尾部
  link.click();
  axios
    .post("/api/Cam/AllowInsertDownload", {
      CamEdition: softWare3.value.id,
    })
    .then((response) => {
      if (response.data.code != 200) {
        message.error(response.data.info);
      }
    })
    .catch((error) => {
      console.error(error);
    });
};
const download4 = () => {
  let link = document.createElement("a");
  //创建一个a标签
  link.style.display = "none";
  //将a标签隐藏
  link.href = softWare4.value.fileurl;
  //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
  link.setAttribute("download", softWare4.value.filename);
  // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
  document.body.appendChild(link);
  //将上面创建的a标签加入到body的尾部
  link.click();
  axios
    .post("/api/Cam/AllowInsertDownload", {
      CamEdition: softWare4.value.id,
    })
    .then((response) => {
      if (response.data.code != 200) {
        message.error(response.data.info);
      }
    })
    .catch((error) => {
      console.error(error);
    });
};
</script>

<style scoped>
#tf-bodorcam {
  padding: 100px 0px;
  background-color: #f7f9fa;
}
.zeropadding {
  padding: 0px;
}
.card {
  box-sizing: border-box;
  border: none;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  margin: 20px 0px;
  overflow: visible;
  transition: all 0.4s;
  font-size: 14px;
  background-color: white;
}
.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.card-head {
  width: 100%;
  align-items: center;
  color: #333;
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
}
.card-content {
  width: 100%;
  min-height: 50px;
  padding: 15px;
  display: flex;
  flex-direction: column;
}
.vers_card_content {
  width: 100%;
  min-height: 50px;
  padding: 15px 0;
  display: flex;
  flex-direction: column;
}
.info {
  display: flex;
  justify-content: space-between;
  min-height: 200px;
}
.introduct {
  margin-top: 40px;
}
.fileicon {
  width: 200px;
  height: 200px;
  margin: 0px 30px;
  cursor: pointer;
}
.verticalline {
  width: 1px;
  background-color: #e3e4e6;
  margin: 0px 30px;
}
.infocontent {
  flex-grow: 1;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  min-height: 200px;
}
.infoitems {
  border-color: #c0c6cc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  height: 80px;
  position: relative;
  text-align: left;
  border-radius: 4px;
  padding: 12px;
  width: 48%;
  text-decoration: none;
  background: #f7f9fa;
  border: 1px solid transparent;
  transition: all 0.1s linear;
}
.infoitems:hover {
  border-color: #c0c6cc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
}
.infotitle {
  line-height: 18px;
  height: 18px;
  color: #555;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 18px;
  height: 18px;
}
.infonumber {
  display: block;
  line-height: 50px;
  height: 50px;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.btngroup {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-right: 20px;
}
@media (max-width: 767px) {
  .info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 200px;
  }
  .btngroup {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
  }
  .introduct {
    margin-top: 20px;
  }
  .jumpBtn {
    width: 48%;
    height: 40px;
  }
  h2 {
    line-height: 50px;
  }
}
.noradius {
  border-radius: 0px;
}
.customstyle {
  background: #f7f9fa;
  border-radius: 4px;
  margin-bottom: 10px;
  overflow: hidden;
  border-color: #c0c6cc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  border: 1px solid transparent;
  transition: all 0.1s linear;
}
.customstyle:hover {
  box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.softwarebox {
  margin-bottom: 20px;
}
.artticle {
  width: 100%;
  border: none;
  background-color: rgb(250, 250, 250);
  padding: 0 8px;
  margin-bottom: 0px;
  font-family: Menlo, Monaco, Consolas, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
a {
  color: #1890ff;
}
#cam {
  padding: 100px 0px;
  background-color: #f7f9fa;
}
.skletonBox {
  padding: 0px 20px;
  border: 1px solid #e3e4e6;
  border-radius: 10px;
  margin-bottom: 20px;
  /* background: #c0c6cc; */
}
.container_title {
  overflow: hidden;
  margin: 30px 0 15px;
}
.container_title_left {
  width: 6px;
  height: 30px;
  background: #ff4610;
  float: left;
}
.container_title_right {
  font-size: 24px;
  line-height: 30px;
  font-weight: 600;
  float: left;
  margin-left: 10px;
}
.container_content {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.container_content_left {
  width: 49%;
  background: #fff;
  border-radius: 8px;
}
.container_content_right {
  width: 49%;
  background: #fff;
  border-radius: 8px;
}
.version {
  padding: 30px 20px 10px;
}
.vers_head {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.vers_head_left {
  display: flex;
  flex-wrap: nowrap;
  justify-content: left;
}
.vers_fileiconBox {
  background: #ecf0ff;
  width: 100px;
  height: 75px;
  border-radius: 5px;
  float: left;
  text-align: center;
  line-height: 75px;
  margin-right: 20px;
  cursor: pointer;
}
.vers_fileicon {
  width: 80px;
  height: 60px;
}
.vers_title {
  float: left;
}
.vers_btnBox {
  width: 80px;
}
.vers_btngroup {
  width: 100%;
}
.vers_button {
  background: #ff4610;
  color: #fff;
  border: 0;
  border-radius: 5px;
  margin-bottom: 5px;
}
.vers_title_bold {
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
}
.vers_title_small {
  font-size: 14px;
  line-height: 30px;
  color: #999;
}
</style>
